import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarStore {
  public activeCollapsible = signal<string | null>(null);

  public toggleCollapsible(title: string){
    this.activeCollapsible.update(current => current === title ? null : title);
  }
}
